import React from "react";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { FaDatabase } from "react-icons/fa";
import { useSelector } from "react-redux";
import DashboardCard from "../../Components/Cards/DashboardCard";
import { ROUTES } from "./constants";
import { useGetDashboardDetailsQuery } from "../../Data/services/dashboardApi";
import MonthlyPostsChart from "../../Components/MonthlyPostGraph/MonthlyPostGraph";
import styl from '../../Components/Cards/DashboardCard';

export default function Dashboard({ setPage }) {
  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetDashboardDetailsQuery();

  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} classes="primary-text" />
        </div>
      </div>

      <Row className={`${styles.matchRow} w-100 mt-2 mb-5 d-flex justify-content-center`}>
        <Col className={`mt-2 mb-2`} lg={6} md={6} sm={6}>
          <DashboardCard
            bg1={"#414042"}
            bg2={"#70D6BD"}
            icon={<FaDatabase color="#70D6BD" />}
            number={data == null ? 0 : data?.data?.user_count}
            text={"Numbers of Users"}
          />
        </Col>
        <Col className={`mt-2 mb-2`} lg={6} md={6} sm={6}>
          <DashboardCard
            bg1={"#414042"}
            bg2={"#70D6BD"}
            icon={<FaDatabase color="#70D6BD" />}
            number={data == null ? 0 : data?.data?.nurse_count}
            text={"Numbers of Nurses"}
          />
        </Col>
        <Col className={`mt-2 mb-2`} lg={6} md={6} sm={6}>
          <DashboardCard
            bg1={"#414042"}
            bg2={"#70D6BD"}
            icon={<FaDatabase color="#70D6BD" />}
            number={data == null ? 0 : data?.data?.active_jobs_count}
            text={"Total Active Jobs"}
          />
        </Col>
        <Col className={`mt-2 mb-2`} lg={6} md={6} sm={6}>
          <DashboardCard
            bg1={"#414042"}
            bg2={"#70D6BD"}
            icon={<FaDatabase color="#70D6BD" />}
            number={data == null ? 0 : data?.data?.completed_jobs_count}
            text={"Total Completed Jobs"}
          />
        </Col>
      </Row>
      <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
        <Col md={12}>
          <div className={`Chart ${styles.card}`}>
            <MonthlyPostsChart />
          </div>
        </Col>
      </Row>
    </div>
  );
}
